import { useMatches, useRouteError, useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';

function ErrorMessage({ notFound, className }: { notFound: boolean; className: string }) {
  const navigate = useNavigate();

  return (
    <div className={`flex items-center justify-center px-4 py-8 ${className}`}>
      <div className="w-full max-w-[440px] text-center">
        <p
          aria-hidden
          className="mb-4 select-none font-mono text-[2.75rem] leading-none text-muted-foreground"
        >
          {'>_<'}
        </p>

        <h1 className="mb-2 font-display text-[1.75rem] font-bold tracking-tight text-foreground sm:text-[2rem]">
          {notFound ? 'This page does not exist.' : 'This page did not load.'}
        </h1>

        <p className="mb-6 text-pretty text-muted-foreground">
          {notFound
            ? 'Check the address, or search for the tool that you want.'
            : 'Reload the page to try again, or search for another tool.'}
        </p>

        {/* An error boundary can render outside Layout, where the tools dialog does not exist. Home holds the same search. */}
        <Button onClick={() => navigate('/')} className="h-11 px-6">
          See All Tools
        </Button>
      </div>
    </div>
  );
}

const ErrorPage: React.FC = () => {
  const error: any = useRouteError();

  console.error(error);

  return (
    <main className="page-background">
      <ErrorMessage notFound={false} className="min-h-screen" />
    </main>
  );
};

/** An address with no route. It renders inside the shell, so the bar and its Home button stay. */
export function NotFoundPage() {
  return <ErrorMessage notFound className="flex-1" />;
}

/** True on the catch-all route, where a path such as /events/foo only looks like a tool. */
export function useIsNotFound() {
  return useMatches().some(({ handle }) => (handle as { notFound?: boolean } | undefined)?.notFound);
}

export default ErrorPage;
